import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import { ActivityService } from '../../core/services/activity.service';
// import * as _ from 'lodash';
import countBy from 'lodash/countBy';

@Injectable({
  providedIn: 'root',
})
export class JoiningBonusPdfService {
  bonusDataPoint: any;
  showHeaderFooter = false;
  selectedCandidate;
  joining_b;
  template_;
  fname;
  mname;
  lname;
  Title;
  joining_bonus;
  PresentAddressLine1;
  add2: any;
  siB: any;
  offerLetterDate: any;
  doj: any;
  pageNo: number;
  spclBns_sib: any;
  special_bonus;
  candidateId: any;
  companyHiringType= Number(localStorage.getItem("fresherCompanyHiringTypeId"));

  constructor(private activityService: ActivityService) {}

   setBonusSign(doc: jsPDF, y: number = 270) {
    const signImg =
      'data:image/png;base64,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';
    doc.addImage(signImg, 'PNG', 35, y, 80, 40);
  }

  setBonusDataPoint(datapoints) {
    this.bonusDataPoint = datapoints;
  }
  private renderAddress(doc: jsPDF, pageHeight: number, pageWidth: number, lineHeight: number): void {
    const lines = [
      'INFOSYS LIMITED',
      'CIN: L85110KA1981PLC013115',
      '44, Infosys Avenue',
      'Electronics City, Hosur Road',
      'Bangalore 560 100, India',
      'T 91 80 2852 0261',
      'F 91 80 2852 0362',
      'askus@infosys.com',
      'www.infosys.com',
    ];
    const maxLen = Math.max(...lines.map((l) => l.length));
    const xRight = pageWidth - (maxLen * 4 + 105);
    let yBottom = 80;
    for (let i = lines.length; i > 0; i--) {
      doc.text(lines[i - 1], xRight, pageHeight - yBottom);
      yBottom += lineHeight;
    }
  }

  private classifySignOnText(
    text: string,
    inSignatureBlock: boolean,
  ): 'sign-img' | 'numbered' | 'sub-item' | 'sig-name-bold' | 'normal' {
    if (text === 'sign_img') return 'sign-img';
    if (inSignatureBlock && text.trim() !== '') return 'sig-name-bold';
    if (/^[a-z]\.\s/.test(text.trim())) return 'sub-item';
    if (/^\d+[.\s]/.test(text.trim())) return 'numbered';
    return 'normal';
  }

  generateSignOnBonusSheet(dataToPrint): Promise<any> {
    return Promise.resolve(
      (() => {
        this.showHeaderFooter = true;
        const doc = new jsPDF('p', 'pt', 'a4');
        doc.setFont('times');
        doc.setFontSize(11);
        this.setLogo(doc);
        const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
        const pageHeight = doc.internal.pageSize.getHeight();
        const pageWidth = doc.internal.pageSize.getWidth();
        // let footerHeight = 200;
        const footerText = 'Company Confidential - This communication is confidential between you and Infosys Limited ';
        var yPos = 75;
        var xPos = 35;
        const rightBoundary = pageWidth - xPos;
        let inSignatureBlock = false;
        let currentPage = 1;
        const page1BottomLimit = pageHeight - 220;
        const otherPageBottomLimit = pageHeight - 80;
        const clauseList = dataToPrint.clauses.sort((a, b) => (a.clauseSequenceId > b.clauseSequenceId ? 1 : -1));
        for (let i = 0; i < clauseList.length; i++) {
          const clauseItem = clauseList[i];
          yPos += lineHeight;
          if (yPos > (currentPage === 1 ? page1BottomLimit : otherPageBottomLimit)) {
            currentPage++;
            yPos = 80;
            this.addInformationHeader(doc);
            doc.setFontSize(11);
          }
          doc.setFont('times', 'bold');
          doc.setTextColor('black');
          doc.text(clauseItem.clauseTitle, xPos + 175, yPos);
          doc.setFont('times', 'normal');
          doc.setTextColor('black');
          yPos = yPos + lineHeight + lineHeight;
          const textList = clauseItem.texts.sort((a, b) => (a.sequenceNo > b.sequenceNo ? 1 : -1));
          for (let j = 0; j < textList.length; j++) {
            doc.setFont('times', 'normal');
            const txt = textList[j];
            txt.text = this.displayText(txt.text);

            const kind = txt.textId === 796 ? 'sub-item' : this.classifySignOnText(txt.text, inSignatureBlock);
            const startX = kind === 'sub-item' ? xPos + 40 : kind === 'numbered' ? xPos + 30 : xPos + 10;
            const splitWidth = rightBoundary - startX;
            const splt = doc.splitTextToSize(txt.text, splitWidth);
            const lines1 = splt.length;
            let blockHeight = lines1 * (kind === 'sub-item' ? 15 : lineHeight);

            const bottomLimit = currentPage === 1 ? page1BottomLimit : otherPageBottomLimit;
            if (yPos + blockHeight > bottomLimit) {
              currentPage++;
              yPos = 80;
              this.addInformationHeader(doc);
              doc.setFontSize(11);
              doc.setFont('times', 'normal');
            }

            if (kind === 'sign-img') {
              this.setBonusSign(doc, yPos);
              blockHeight = 40;
            } else if (kind === 'sig-name-bold') {
              doc.setFont('times', 'bold');
              doc.text(splt, xPos, yPos - 25, { maxWidth: rightBoundary - xPos });
            } else if (kind === 'sub-item') {
              let newYPos = yPos;
              for (const line of splt) {
                let newXPos = xPos + 40;
                const segments = line.split('|');
                // last line stays natural; non-last lines justified to splitWidth boundary
                const isLastLine = line === splt[splt.length - 1];
                const strippedLine = line.replace(/\|/g, '');
                const wordCount = strippedLine.trim().split(/\s+/).length;
                doc.setFont('times', 'normal');
                const xFactor =
                  !isLastLine && wordCount > 1 ? (splitWidth - doc.getTextWidth(strippedLine)) / (wordCount - 1) : 1;
                for (let k = 0; k < segments.length; k++) {
                  doc.setFont('times', k === 1 ? 'bold' : 'normal');
                  newXPos = this.myCustomSplitLine(doc, segments[k], newYPos, newXPos, xFactor);
                }
                newYPos += 15;
              }
            } else if (kind === 'numbered') {
              doc.text(splt, xPos + 30, yPos, { align: 'justify', maxWidth: splitWidth });
            } else {
              doc.text(splt, xPos + 10, yPos, { align: 'justify', maxWidth: splitWidth });
              if (txt.text.trim() === 'For Infosys Limited,') {
                inSignatureBlock = true;
              }
            }

            yPos += blockHeight + lineHeight;
            if (j === textList.length - 1) {
              yPos -= lineHeight;
            }
          }
        }
        doc.setFont('times', 'normal');
        doc.setPage(1);
        this.renderAddress(doc, pageHeight, pageWidth, lineHeight);
        const numOfPage = doc.internal.pages.length;
        for (let i = 1; i < numOfPage; i++) {
          this.setFooterForInfoBonus(doc, footerText, i);
        }
        //    doc.save('signOnbonus.pdf');
        this.siB = doc.output('datauristring');
        const joiningBonusSheet = doc.output('blob');
        console.log('Sign-on Bonus', URL.createObjectURL(doc.output('blob')));
        
        return this.blobToFile(
          joiningBonusSheet,
          this.companyHiringType == 11 ? `${this.selectedCandidate.candidateId}-SignOnBonus` : 'SignOnBonus',
        );
      })(),
    );
  }

  numberWithCommas(x) {
    if (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return '';
    }
  }

  blobToFile(theBlob, fileName) {
    const b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.fileName = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }

  setLogo(doc: jsPDF) {
    const base64_source =
      'data:image/png;base64,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';
    doc.addImage(base64_source, 'PNG', 450, 20, 100, 50);
  }

  setFooterForInfoBonus(doc: jsPDF, str, pageNo) {
    if (this.showHeaderFooter == true) {
      doc.setPage(pageNo);

      let yPos = 20;
      const pageCount = doc.getNumberOfPages();
      const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
      doc.setFont('times', 'normal');
      doc.setFontSize(10);
      // if (pageNo !== 1) {
      doc.text('Page ' + pageNo + ' of  ' + pageCount, pageWidth / 2, pageHeight - yPos, { align: 'center' });
      // }
      yPos += lineHeight;
      doc.setFont('times', 'Italic');
      doc.text(str, pageWidth / 2, pageHeight - yPos, { align: 'center' });
      doc.setFont('times', 'normal');
    }
  }

  addInformationHeader(doc: jsPDF) {
    doc.addPage();
    this.setLogo(doc);
  }

  displayText(text): string {
    // console.log(this.selectedCandidate)
    // console.log("candidate->", this.PresentAddressLine1)
    const jb = this.joining_bonus ? this.joining_bonus : null;
    const candidate = {
      fname: this.fname,
      Title: this.Title,
      title: this.Title,
      joining_bonus: this.numberWithCommas(this.joining_bonus),
      PresentAddressLine1: this.PresentAddressLine1.address1,
      PresentAddressLine2: this.PresentAddressLine1.address2,
      city: this.PresentAddressLine1.cityName,
      state: this.PresentAddressLine1.stateName,
      // "PresentAddressLine4": this.PresentAddressLine1.countryName,
      PresentAddressLine5: '',
      Name: this.fname + ' ' + this.lname,
      half_joining_bonus: this.numberWithCommas(jb / 2),
      Date_of_Offer: this.offerLetterDate,
      doj: this.doj,
      special_bonus_amount: this.special_bonus,
    };
    const result = text.replace(/\<\<(.*?)\>\>/g, function (match, token) {
      return candidate[token];
    });
    return result;
  }

  getCurrentFinancialYear2(doj) {
    let fiscalyear = '';
    const today = new Date(doj);
    if (today.getMonth() + 1 <= 3) {
      fiscalyear = today.getFullYear() - 1 + '' + '-' + (today.getFullYear() + '').slice(-2);
    } else {
      fiscalyear = today.getFullYear() + '' + '-' + (today.getFullYear() + 1 + '').slice(-2);
    }
    return fiscalyear;
  }

  myCustomSplitLine(doc, txt, yPosition, xPos, maxWidth) {
    const words = txt.trim().split(/\s+/);
    for (let k = 0; k < words.length; k++) {
      doc.text(words[k], xPos, yPosition);
      const temp = doc.getTextWidth(words[k] + ' ');
      xPos = xPos + temp + maxWidth;
    }
    return xPos;
  }
  generateSpclBns(dataToPrint) {
    const valToPrint = dataToPrint.clauses.sort((a, b) => (a.clauseSequenceId > b.clauseSequenceId ? 1 : -1));
    return Promise.resolve(
      (() => {
        const doc = new jsPDF('p', 'pt', 'a4');
        doc.setFont('times');
        this.pageNo = 1;
        this.setLogo(doc);

        const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;

        const pageHeight = doc.internal.pageSize.getHeight();
        const footerText = 'Company Confidential - This communication is confidential between you and Infosys Limited ';
        let yPos = 95;
        let xPos = 35;
        if (valToPrint) {
          valToPrint.forEach((element) => {
            let stdXPos = 35;
            let clsuseCopy = JSON.parse(JSON.stringify(element));
            while (clsuseCopy.parentClause !== null) {
              const parentClause = valToPrint.find((res) => res.clauseId === clsuseCopy.parentClause);
              if (parentClause) {
                clsuseCopy = parentClause;
                stdXPos += 20;
              } else {
                break;
              }
            }
            console.log(element, stdXPos);
            xPos = stdXPos;
            if (element && element.texts) {
              if (element.texts.length == 0) {
                doc.setFont('times', 'bold');
                doc.setFontSize(14);
                // yPos -= lineHeight;
                doc.text(element.clauseTitle, xPos, yPos);
                yPos += lineHeight;
              }
              doc.setFontSize(11);
              if (element.clauseType == 'Clause') {
                yPos += 10;
              } else {
                yPos += 5;
              }
              element.texts = element.texts.sort((a, b) => (a.sequenceNo > b.sequenceNo ? 1 : -1));
              element.texts.forEach((textval, indx) => {
                //remove white space from text
                textval.text = this.displayText(textval.text);
                if (element.clauseName !== 'Salutation') {
                  textval.text = textval.text.trim().replace(/\s+/g, ' ');
                }
                let blkHeight = 0;
                if (element.clauseId !== 369) {
                  const spltTexts = doc.splitTextToSize(textval.text, 557 - stdXPos);
                  const noLines = spltTexts.length; // splitted text is a string array
                  blkHeight = noLines * lineHeight;
                } else {
                  blkHeight = 80;
                }
                if (yPos + blkHeight > pageHeight - 75) {
                  yPos = 95;
                  this.addInformationHeader(doc);
                }
                if (indx === 0 && element.clauseTitle) {
                  xPos = 35;
                  doc.setFont('times', 'bold');
                  doc.text(element.clauseTitle, xPos, yPos);
                  doc.setTextColor('black');
                  // yPos += lineHeight + 10;
                }
                let splitParagraph;
                if (element.clauseId !== 369) {
                  splitParagraph = doc.splitTextToSize(textval.text, 557 - stdXPos);
                  const nOsLines = splitParagraph.length; // splitted text is a string array
                  blkHeight = nOsLines * lineHeight;
                  doc.setFont('times', 'normal');
                  // let spltText = splitParagraph;
                  for (let i = 0; i < splitParagraph.length; i++) {
                    if (element.clauseName === 'Salutation') {
                      xPos = 35;
                      doc.text(splitParagraph[i], xPos, yPos);
                    } else {
                      let newxXpos = xPos;
                      if (i == splitParagraph.length - 1) {
                        // if its last line, space between text is 1
                        const innersplit = splitParagraph[i].split('|');
                        const pipeCount = countBy(splitParagraph[i])['|'];
                        innersplit.map((text, i) => {
                          if (text) {
                            doc.setFont('times', 'bold');
                            // every even item is a normal font weight item
                            if (i % 2 === 0) {
                              doc.setFont('times', 'normal');
                            }
                            if (pipeCount == 1) {
                              doc.setFont('times', 'bold');
                            }
                            const returnX = this.boldTextPrint(doc, text, yPos, newxXpos, 1); // with bold
                            newxXpos = returnX;
                          }
                        });
                      } else {
                        const innersplit = splitParagraph[i].split('|');
                        if (innersplit.length > 1) {
                          // if line contain | do bold logic
                          const xFactor = this.getXPos(splitParagraph[i], doc, newxXpos); // calculate space factor
                          innersplit.map((text, i) => {
                            if (text) {
                              doc.setFont('times', 'bold');
                              // every even item is a normal font weight item
                              if (i % 2 === 0) {
                                doc.setFont('times', 'normal');
                              }
                              const returnX = this.boldTextPrint(doc, text, yPos, newxXpos, xFactor); // with bold
                              newxXpos = returnX;
                            }
                          });
                        } else {
                          this.normalTextPrint(doc, splitParagraph[i], yPos, newxXpos); // without bold
                        }
                      }
                    }
                    yPos = yPos + 15;
                  }
                  yPos = yPos + 5;
                } else {
                  xPos = 35;
                  yPos = this.setSignature(doc, xPos, yPos, textval.text);
                }
              });
            }
          });
        }
        const numOfPage = doc.getNumberOfPages();
        for (let i = 1; i <= numOfPage; i++) {
          this.setFooterForInfoBonus(doc, footerText, i);
        }
        this.spclBns_sib = doc.output('datauristring');
        // doc.save('special_bonus.pdf');
        console.log('Special bonus addendum generated');
        const spclBonusSheet = doc.output('blob');
        return this.blobToFile(spclBonusSheet, 'Special Bonus');
      })(),
    );
  }
  normalTextPrint(doc, txt, yPosition, xPos) {
    const remSpace = 555 - xPos - doc.getTextWidth(txt);
    const words = txt.trim().split(/\s+/);
    const wordSpacing = remSpace / (words.length - 1);
    for (let k = 0; k < words.length; k++) {
      if (words[k]) {
        doc.text(words[k], xPos, yPosition);
        xPos = xPos + doc.getTextWidth(words[k] + ' ') + wordSpacing;
      }
    }
    console.log(xPos, 'normal');
  }
  boldTextPrint(doc, txt, yPosition, xPos, maxWidth) {
    const words = txt.trim().split(/\s+/);
    for (let k = 0; k < words.length; k++) {
      if (words[k]) {
        doc.text(words[k], xPos, yPosition);
        const temp = doc.getTextWidth(words[k] + ' ');
        xPos = xPos + temp + maxWidth;
      }
    }
    console.log(xPos, 'bold');
    return xPos;
  }
  getXPos(txt, doc, xPos) {
    const matches = txt.match(/\|.*?\|/g); // match all text between '|' characters
    const result = [matches.map((match) => match.replace(/\|/g, '')).join(' ')]; // remove '|' characters and combine all matches into one string
    const nonMatches = txt
      .split(/\|.*?\|/)
      .filter(function (item) {
        return item.trim() !== '';
      })
      .map(function (item) {
        return item.trim();
      }); // split text at '|' characters and remove matches
    result.push(nonMatches.join(' ').trim()); // combine non-matches and trim any leading/trailing whitespace

    let totalTxtWidth = 0;
    if (result[0]) {
      doc.setFont('times', 'bold');
      totalTxtWidth += doc.getTextWidth(result[0] + ' ');
    }
    if (result[1]) {
      doc.setFont('times', 'normal');
      totalTxtWidth += doc.getTextWidth(result[1]);
    }
    const remSpace = 555 - xPos - totalTxtWidth;
    const words = txt.trim().split(/\s+/);
    return remSpace / (words.length - 1);
  }

  setSignature(doc, xPos, yPos, base64Str) {
    doc.addImage(base64Str, 'PNG', xPos, yPos, 80, 40);
    return (yPos += 60);
  }
  generateJnslBns(dataToPrint): Promise<any> {
    this.pageNo = 1;
    const valToPrint = dataToPrint.clauses.sort((a, b) => (a.clauseSequenceId > b.clauseSequenceId ? 1 : -1));
    return Promise.resolve(
      (() => {
        const doc = new jsPDF('p', 'pt', 'a4');
        doc.setFont('times');
        this.pageNo = 1;
        this.setLogo(doc);

        const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
        const pageHeight = doc.internal.pageSize.getHeight();
        const pageWidth = doc.internal.pageSize.getWidth();
        let yPos = 95;
        let xPos = 35;

        // Display ANNEXURE text first for joining bonus on first page
        if (this.pageNo == 1) {
          doc.setFont('times', 'bold');
          doc.setFontSize(12);
          const annexText = 'ANNEXURE 1 : Joining Bonus';
          doc.text(annexText, pageWidth / 2, yPos, { align: 'center' });
          doc.setFont('times', 'normal');
          doc.setFontSize(10);
          this.setHeader(doc, true);
          this.setBpmJbFooter(doc, 1);
        }
        if (valToPrint) {
          valToPrint.forEach((element) => {
            const stdXPos = 35;
            // Force clause 7901 to start on a new page
            if (element.clauseId === 7901) {
              yPos = 95;
              this.addHeader(doc);
            }
            // ...existing code...
            console.log(element, stdXPos);
            xPos = stdXPos;
            if (element && element.texts) {
              doc.text(element.clauseTitle, xPos, yPos);
              if (element.texts.length == 0) {
                doc.setFont('times', 'bold');
                doc.setFontSize(14);
                // yPos -= lineHeight;
              }
              doc.setFontSize(11);
              if (element.clauseType == 'Clause') {
                yPos += 10;
              } else {
                yPos += 5;
              }
              element.texts = element.texts.sort((a, b) => (a.sequenceNo > b.sequenceNo ? 1 : -1));
              element.texts.forEach((textval, _indx) => {
                //remove white space from text
                textval.text = this.displayText(textval.text);
                textval.text = textval.text.trim().replace(/\s+/g, ' ');
                let blkHeight = 0;
                blkHeight = 80;

                if (yPos + blkHeight > pageHeight - 50) {
                  yPos = 95;
                  yPos = this.addHeader(doc);
                }
                // if (indx === 0 && element.clauseTitle) {
                //   xPos = 35;
                //   doc.setFont("times", "bold");
                //   doc.text(element.clauseTitle, xPos, yPos);
                //   doc.setTextColor("black");
                //   // yPos += lineHeight + 10;
                // }
                const splitParagraph = doc.splitTextToSize(textval.text, 557 - stdXPos);

                const nOsLines = splitParagraph.length; // splitted text is a string array
                blkHeight = nOsLines * lineHeight;
                doc.setFont('times', 'normal');
                // let spltText = splitParagraph;
                for (let i = 0; i < splitParagraph.length; i++) {
                  if (splitParagraph && splitParagraph[0].includes('Signature_Image')) {
                    yPos -= 10;
                    const signBase64 =
                      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAACECAYAAABmikyTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxMAAAsTAQCanBgAABYLSURBVHhe7Z0LdFXllcdz3+9nbu4jyc3Ni+SSkISUioRBwwKMFiyWRfEJVLG2Lm2t1jqKo0WpqKuiHa2PdqmjtM5CKaVWO3aGMuPbvqyigkwV32ABFSHkRV53/vvcLxkwXLhJ7g0J/H9rnXXO2efc8/jOt7+99/e6OYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQsYsOrUmo4yqqirnjh3bqgwGS7yzsz3c2dnj1etzchIJ3fNtbW2/V6cRQjJNXl5endVqfchoNHbodLo2LNtk0ev127EksJ0wmUxPe73ek9RPCCGZIBgMNjgcjrVQvl4sT5jN5tkQG5JH+7HabLb5OPacXq9LmM3GB8vLyy3qGBmjHEvuqM7v97uQgU9saWmJ9PT0xHt7e22wHrFEouczg8G0A5l3IyzNH7Zu3dqsfnPUiUQigb17967p6OiYjmd91G63/7C5uXmrOpwSn8/3/ebmvSt1upwN3d29cyHqSB4hZARobGw0QpnKYD3OhfVYAevwisls+txgMCTEZcPyMbb/gvUGuG4bsP0LLGuwvwX7rVar+Tpcxpy82tFDrBie/RmdXtcFpbpGidPG7XbfIe4pCp7Hscv4nmQXn8/VYLFYboAS/Q+WPch4u6BUL4uCYftSrKcjQ0+GNSxUPzkUOmT2M3F+J367DvvWpPjo4Pe7m0SJEANev2jRonMrKyvnq0NpUVRU5DOZjO2whqKIP1BiQjKGAVauGoq33Gg0/ANK84bBoFuJDHv2ERTtiEARH5GMC2X+mRIdFfBOi6E8G6uqqszxeOUGsYjYn6wOp4XFYnpC3gWbK5MSQoZJLBazIi66CJnxVVg3lPD69U6n82s4lDF3KxQKTYBi98IK9UARq5X4IPLz86M+n+cmm922wWazrHYFXBXqUMbA/W/Cuy475ZRTHE6nYzdEUvv5RPJoeoh3QCUkmUKHGOcsuFdbYCE6kLlWBgKBiDqWcZD575PMC+t6pxL1U1tb67BaLX8XV1FqIeU8LDerwxkDBc0lZrP5ARQ8V+Cd++4jruVUdcoRgVdwvvwGmz9PSggZAlC+02CR3oTl6zabjas9Hk+pOpQ14JKeJUqGZUDmDQaD58gxuL535ubm/kq2oRiDrjg5ErhPqclsarbarK3YTcDiPo/CRyx02o3x1dUVJ2jvkZOzVokISR9YAC8y3U9gBXphAZ8cbqw3GEpLS2eLu4t7X6hE/Thdzk0Gg36n9FpBrPYAMnmLy+XKVYczisVmuVgsGSxud3l5edmECdX/jvvtx6GC5BmHZ86cOXWihNikOzpG0av1iIM4L759+/YXuru7F8PiXNDV1T139+7d29ThrNPe3m5OJBI5UMSNSqQRiUSK2tvaqu0Ox+bKynGLd+zY8RWIX9u3b99nyTMyi0Fn+K1Op32G3q6urs/Ky8ddBld4HxTrKu2EI/D22/8bV5uEpI/DYT0LFmgfXLyn8vLywko8YkyZMsXmcjlfgQv8HnaNSWmSYDDwPawSTqcj4fG4xV0Vt/SO5NHMEwh4G+UeYg1hbbVmBqTJNZBtx6ZT9g+H1+teihUtIUkfu91+vVRCmCymrGXsI6ALBAJr8QzNTr9zvJL1Ewrl3Y+VZGpNMaCoT0+aNMmkHcwC8AiegsLtQoz6K9yrDZZ4Ul1dnddut7Xg8JnJs1JjtZrvl+eERb9RiQhJDRRwiZT6iAN/pEQjiihTIOC/VwoBWDfpNTOAaDT6IFaaEuK8v8Vi2bPURUVFs1RcernsI31ON5tN70jzCAqK3yCt/qKdmAJRVrxHa45O67KWn5SSTFFaWuqpqKiIB4PBM9xu9/0oMFdFIuG7Y7HY5ZDVqtPGDniBKrE+JrPpp0o0osTj8Vx/rv8lpYBS+3jIeDhWHHsSK80KOp3WxqQ08zQ2Nlp9Pu823KcNu/0usdlsnm+xmP9aUBB5VAosuOwpnyEvz/91OQfL20pEhokonsPhuBx55E9I+/2SX1BQtmO7RRakdbekucGg74QxuaO8PGdsdKCHq1WNF/kALyEZ/KAYbCQIh8OLbDbrDiRou9Np/6l0CFCHDuLUU0+KeL2ej7EpmV8qYrJWcRWNFvxY2iCRLq8pUT9+v/9WZAQtHsXylBIPAAXbi1jJOYwHh4n045WYHN99N5bNUMIH8vJyL/F4PDOkwJT+yuJJFRUVLBLvRX0b8ZiKk1cYxeAlivHQHxqNhjdjMY9XiUcEKF8MLt5alFqwfpaNyNxV6tAhKSws/EUycbUY6w0lzjiVVZVXwu3skXvB8n1ViQ8CseEvpRTGOXuROSqVuJ/i4uI6PGMPNuVZ5ySlZLBIl0Gv1/sviMGfQUz+hM/nkiFk/YWvKOe4ceMKkHeWIC89AwWVdtw+JfwDThndHefz8125eOhNyCTbEeNkvNtXKpCB7V6v+zYk6n5k8tdREMxTh1IimRpuoMSrm1Wt6D6IBz3SYurUqa7TTjvtkC6KtDsWFBT8SO6TrPQxpKycmjVrlgfu6svysZF+EqcehNvrlsZ5iSe7YDWDSSkZLPCK4ojNV9XX19eOHz++vqAgNAeF3mVQuNWwhm8g/+5VhaF8h/3IU3/G+jZ4IWek8qhGFXgJGUbUgpKmRomyDpR9NhTvXSRcJ9bXiBuhDqVEzvH7fdJdLoGAe+bJJzecgN/uxMf4dTq/7wNxZxMC+ASUoh0f8fZg0FsD6wq9K6jz+71wMe27lAu6B8p+sfpZSiorK4sdLscnkgGQlkVKjIxTOA+Zo6/y6LtJKUmH6urqMijczLKy4u+Gw6ENUKZtUKweSU94a9JpQlM4Kdyw/RzywX/abLYbQqHQdCnc1WXGBng5af/q9XhcI1ITioxeiHuuhuvZi8Tcie1p6tARicWid+mQ+FCSe5VI2up+IB/E4/O8hmB9ghIfFsS+D4qFkwW7CbkmFA5Lf0m6z2w2XjGY0fDFxfmV+N2H+P3tsl9WVjYV8W1L0mXW/1U7iQxAPImSkpJT8B2XIg8udzgd/4U80QmF65XCVhb5JkmF04kSvoF0lt5bi6F0EiJkrVlqxMDLXI2X6pAxb0qUFaT/JSzPfUjc7qSLZ3oB/ntaXb4EKMRCxGe9+N1z2O23emIB4Q6ul2uiNPwU1jymDh0SfPBZcDPbpeDBu6+Dsi2Fu3kPfrvJZDK+Cct3I9ziIaUFrOCZeI49FRXlN+M6H0EkCi4xq0s7gegqKipKYK0ugPfyHBQuYXfYv6Boeqls68H3aBaFs1gt/4G0/BYUbt5g8suYQq/PuRov/IHazThI8KDDYfsxElQb1AqF344EvQyHvjgvS0pqasbPgtvYg5JQntOTlP4/cAddTqddU0Tc5wPc85A1YYj15iKwl4mZevEM31HijIJra6M6sCkK+CyeO2sjTEY7NTXxL0Uiwcth2Z7E8pLT5fzcZDZpnkef0qFQ/RTf7E0sW6Bst8OVPEmaH9Qljg/EEsJtekftZgzxy1Ha3YrEbRXlwH32w1JcNdheLdOm1fgQvyF21HUjQ5+qxAOApcRprndycC8o2J5oNHqGOqQBN/grcGOlxqwTz7FIiTMOCpmPdMkY8H3sHjdTWeC72isqYnF4Io1wK++WpqZk7Ja0crJGYS/LJ1ar5Ql8y2uRP8bhp8dNGqVElBClkQzRyVi7YCAQaITr+F5S+XQduP59B1ZYpIu4mqFQ3m9ViblQiVMSj8cjUMRX+z46StaXoZnrnIgz8HvJDHuRCWTgcVZweV2L8L64j6aEx0XDvIywyc/PPx8F3y4UQP0WThbsd8L1fwwx+PdRCNZWf7k6qn5GDsTlss+RBPP53Gcr0ZAoLi440efzLIfbIVXDkgm7kfHXYv+wbX6HA27ld0SZcJ31SpQOBpSw34AF3irKgP0+pXgDCjigHS9TiCVGhtsp9+rLjLjneerwMQXcxaBUpODbPopv0yXvCqsnzUy7sTyEY18PBnNn4jtkZVjZMQkyy+tIzM0yakGJ0qKmpqYQpeD1SOx3xfVQlk/isrUo/dKqqUxFSUlJCNZzH55tdyjkKVHitJGaTXCh3W69HqW01KJldTgY3vciVfo/j8LDAXdrJfZ7sJ/ShR4LSDpCqRbg/e50OByrEFPLBF7SLCDv+gLe81+xvxj5oGLBggVpx/nkC6D0mi8ZCP78JUqUEmnghvItCIWCv0eMpZX4UMAuWIFtUJp7MtHWKB8eccV6XLsXH/mbSjyaMUDhpXlCqtD/SclMkL2FQmQPLEaeko16pGdKSUlBLRTvAo/H8zN8013yjbF0Qem2GI36x+12y/l4J46PzDBIX8MzUMZuuBrfmzp16oCe/lIDWVRUdDuUrA3nai4X4q9dKPWvwYfL6AgGv9+/TD487nG0hlENiry8XBlXiOfV3aNEGrm5uTOhhDIDtzRTjNr2LMR1YSjV1xwO2wNQumZ5ZnkfrHegUFkHS7cwVY0zySBSqyUJL24l3LcEPsqmUDi0orq6en4wHFwGy/SZltFwvKS05P3JkydfIbOPqZ9nDBl6gg/fDXdns7h1SjxqkcojZNxN2PwQy4D2Rbhw/yZuOjLyURkWlgJ9PB5v8Pu918uz45v397PE9kf41rfA/fw2luOrqeBok58fOlv8fGz2L30fRhbZF+sHi7gc21mpVpZqbpTGG3G/NhQEU5R4VFNQULBAWY4VSnQQcOuccNU/Qdr2IsOnPTtbppF4v7Awcirc+6dRyOFbytAffRcKhw7sr/F4HLNgucXFzGrsTFIjMc2rWPcpn4zH2oIS/O/S7tYnl8xWVBT9U1NT06Qrr7wyo1ZKgnp/wP+IKDwyRcZnTMsG0hYKS/cxnvlz7Kas1IJ73aQqrF7H7oi2ixUXF9S53e6f4PtqY+7wHDLm7tfYX4FnD42Jzs3HCQ58oG5YuvdQUooC9NdyofSOIZPdjOPa+D3JTNLVqLq6avfMmTOXLly4MCMjA5AZrhBLiwwijdwjPpZxKHg8njVSaCBtvq1EqdDBsq8WtxTpme1p8HXl5eVTIpHQhbjnZklTLJ+azKY/Gi3GS1EguNV5ZLSBzCGN6YcrpQ1ms/l0mW8UiiKWUuKcBNyx1okT6+6aPbvpNFizIf15i1hBl8sp/+/XikKgTolHNYhXbxDLgrRIa6yatK0hveRvAnZnuv1MeiH58/wLbDbr0xLPK8WTwuE13PNb2e4XTI4C4obBCsyHS7PKaNL+8CUB5Unk5+e3VldXPzt9+vRLliw597AdqQ+kpKRkiVzDZDLcokSjmsLCwkYpgPDMm7GbtlseDPrnyXtCQYY9dYgoXjQa/bLb7XocBeg+eCj7cV1p712J71JcVVXlz1mQfv9cMrbRoxRuwse/BVbhHbGQWCd8fl8vMusr0WjBSriaF9fW1p44b96pAzozNzY2Wj0et1hBiTuPOHXgKEDvcNg343k/Vd7DoEB89jh+K/OeDLoDQvyEeG4gEDjT6XQ8abVaukShJd2wXgcvRfphEqK1jVUig81EprgXJbNMjiuZJGGxmKUzQAJu3ObS0uJ76uvrG6ZMmeKHO3uTHMciVfyjnkAwcDneqddgyJmlRINCegKhkPoYyxbZVuKUTJw4MQ+F2QVIu9/A3ZQhWJJW/0Da3uF0Ov8Z6Zy1rnjk2ED72zRYSfn3pvXIPPLPu1rpbTabtEl7JXYRmbRP1tdPvPu8884bsSn2B0vp+NJxNrtNZvFarURDItkcpO+2220vHmpUybRp03yxWOG5Pp8PrqalA+dK9zeZVexKs9Msc7By5AEZMiaHw3o23DjJUP1NH32LyPx+Xw9K/vV1dTUXNTU1jZpe92rw8BYooMxpE0hKh47X67lVCiObzXabEklf3JnhcPgRFFzdUDyxeNKOd5/fbzs2B7OSowsUTRshgU2xjO+jpF+FfW0YUnIkgj7h8XoSRcVFLzU0TL70nHPOGXbGHwa6cDi4Gs8mFmlQ/9J7GIxQsJ3S5JOXl/cW3M2dUgjhHjJ7wMtYlrBWk2SVSCT4TVFCZLp9sIz9Fg9WYBZiyl/KeMTknC99FtLfUlpauqKhoSHtWtdMkZ+ff7G4zVgyMiHyxInleVBqaXvtlfeDSNKhFfHdXdJ9MHkWIVnG6XT8DSvJ2DckJQPQS6dhu91+FZR0AxRRG7fmcrlaYiWxawc77GqolJeX1+MZemGxpOJoOFX+Mr/KGYGAX9zNHpniAe+0ye12P4Q0eBfbJ6rzCMk+cL8u1WY4MxraI5GctKany83NzYcyrhNFFAvq8/neKisra1CHs4IMqXK5nFul6x7uuViJ00Z+H41GT5H/1YDifSLWFM/fBYv3R4vDMkOdRsjIEq2M5sPd3INNmW/k6qQ0fTwezwybzfa8KCJ+3xUOh38IcVZqC6HoN4rSY5FG+bQsr1joysrKrwYCgcdhQduSLrfW3Q/xn/53iPXq1amEHB08Ps/DKmN3+nyDb+zuA67qErEsUrHh8bgeE6ujDmWEwsLCAhQW8k+80j3vsAOLZ8yYUQsXeXk4HNoKyyl9cOX9EnqDfiO2l6OwYLMCGR3ANcs3m5PzjsIqyIiCYQEXdRVWWoaHhUwVWw4Jt9t5pyosZP7Qg5Dmirq6uunRWPQBr8+73axNl6+5yS1QuscQ310M13nEK5AIOSJer/eWZMYWV9T4sBIPmfr6+nIoQI+qQe3F9TOW8aFMa+S6WL+kRNKOV1pUXHRdJBLZDuumKZ5Br5dY7zFYy29In1p1KiGjj3i8KGK1WtqkksNkMnYgXvqSOjQsvF7PTrmmskQZm9AXSgVLmLwuYtD/djod7+K5+6Zm/zOU/jpnciY5uplkbBAIBK7VLIdB/5rP5xtyLHggy5Yt0+fm+ndjM2mVDIZD/n3ZELFB0ZbimnegwFgKRbwM+yeHQh7OtULGHlJpghhpGyxIq8ViKVXiYTNhwoTZuF5CLCEU5OmcScfAn4MQkg28Xtfpyq27SYmGhVSM1NRUnY8YUJt8Csr9LMSMxwhJBZRvFdy6ntzc3GH9O5EoH6zq6aFQcCssn7igexC7yUBgxmWEHA6z2bQeseAOUSIlGjRQvilQ4pegdKJ80pH6YcRqx+0/HhEyKKA4WnezYDB4xH+9PQBdTU3NlHB++Dq32/2iUj6ZwuHnB3b4JoSkARSoFgq0F+ueWCx27aEGss6dO9c1efLkk8aNG3dZMJi3xuVyfSKKp9frZM7O3yHuW+LxDJxcl5CRYszHPHa7qW7//p61eJVyuJXbHQ7bBp3O8KbZbA42N+89obW19cS2tnZLT083zta9D6VdDcVb3dXV9RYE0n2MEJIBjHAnZUS5NleKLFC0DshewbIG2xfZbNoocla0EJJN1LybcVjBOCejJYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCskdOzv8BA2PXNK0Bd70AAAAASUVORK5CYII=';
                    yPos = this.setSignature(doc, xPos, yPos, signBase64);
                    splitParagraph[0] = '';
                  }
                  if (splitParagraph && splitParagraph[0].includes('Scheduled_Payment')) {
                    yPos = this.drawSchedulePaymentTable(doc, xPos, yPos);
                    splitParagraph[0] = '';
                  } else {
                    let newxXpos = xPos;
                    if (i == splitParagraph.length - 1) {
                      // if its last line, space between text is 1
                      const innersplit = splitParagraph[i].split('|');
                      const pipeCount = countBy(splitParagraph[i])['|'];
                      innersplit.map((text, i) => {
                        if (text) {
                          doc.setFont('times', 'bold');
                          // every even item is a normal font weight item
                          if (i % 2 === 0) {
                            doc.setFont('times', 'normal');
                          }
                          if (pipeCount == 1) {
                            doc.setFont('times', 'bold');
                          }
                          const returnX = this.boldTextPrint(doc, text, yPos, newxXpos, 1); // with bold
                          newxXpos = returnX;
                        }
                      });
                    } else {
                      const innersplit = splitParagraph[i].split('|');
                      if (innersplit.length > 1) {
                        // if line contain | do bold logic
                        const xFactor = this.getXPos(splitParagraph[i], doc, newxXpos); // calculate space factor
                        innersplit.map((text, i) => {
                          if (text) {
                            doc.setFont('times', 'bold');
                            // every even item is a normal font weight item
                            if (i % 2 === 0) {
                              doc.setFont('times', 'normal');
                            }
                            const returnX = this.boldTextPrint(doc, text, yPos, newxXpos, xFactor); // with bold
                            newxXpos = returnX;
                          }
                        });
                      } else {
                        this.normalTextPrint(doc, splitParagraph[i], yPos, newxXpos); // without bold
                      }
                    }
                    yPos = yPos + 15;
                  }
                }
              });
            }
          });
        }
        this.siB = doc.output('datauristring');
        const spclBonusSheet = doc.output('blob');
        //   this.genModelService.updateBonusSheet(this.blobToFile(spclBonusSheet, 'BPM_Joining_Bonus.pdf'));
        return this.blobToFile(spclBonusSheet, 'Joining Bonus');
      })(),
    );
  }
  drawSchedulePaymentTable(doc, xPos, yPos) {
    // Get joining bonus amount from dynamic data points
    const joiningBonusAmount = this.joining_bonus || 0;
    const halfAmount = joiningBonusAmount / 2;

    // Format amounts with commas for display
    const firstPayrollAmount = joiningBonusAmount > 0 ? `Rs ${this.numberWithCommas(halfAmount)}` : '-/-';
    const afterConfirmationAmount = joiningBonusAmount > 0 ? `Rs ${this.numberWithCommas(halfAmount)}` : '-/-';
    const totalAmount = joiningBonusAmount > 0 ? `Rs ${this.numberWithCommas(joiningBonusAmount)}` : '-/-';

    // Payout table data structure
    const payoutTableData = [
      {
        dateOfPayout: 'Along with 1st payroll*',
        amountInINR: firstPayrollAmount,
      },
      {
        dateOfPayout: 'After confirmation*',
        amountInINR: afterConfirmationAmount,
      },
      {
        dateOfPayout: 'Total',
        amountInINR: totalAmount,
      },
    ];

    const fullPageWidth = doc.internal.pageSize.getWidth();
    const tableWidth = 300; // Fixed table width for centering
    const tableStartX = (fullPageWidth - tableWidth) / 2; // Center the table
    const rowHeight = 25;
    let currentYPos = yPos;
    const bottomPad = 5;

    // Add title "SCHEDULE OF PAYMENT" centered above the table
    doc.setFont('times', 'Normal');
    const titleText = 'SCHEDULE OF PAYMENT';
    const titleX = (fullPageWidth - doc.getTextWidth(titleText)) / 2;
    doc.text(titleText, titleX, currentYPos);
    currentYPos += 10; // Add space between title and table

    // Reset font size for table
    doc.setFontSize(10);

    // Draw table header
    doc.setFont('times', 'bold');
    doc.setDrawColor(0);
    doc.setFillColor(220, 220, 220);
    doc.rect(tableStartX, currentYPos, tableWidth, rowHeight, 'FD');

    // Header text positioning - centered within each column
    const headerY = currentYPos + rowHeight - bottomPad;
    const col1CenterX = tableStartX + (tableWidth * 0.5) / 2;
    const col2CenterX = tableStartX + tableWidth * 0.5 + (tableWidth * 0.5) / 2;

    // Center align header text
    const header1Text = 'Date of Payout';
    const header2Text = 'Amount in INR';
    doc.text(header1Text, col1CenterX - doc.getTextWidth(header1Text) / 2, headerY);
    doc.text(header2Text, col2CenterX - doc.getTextWidth(header2Text) / 2, headerY);

    // Draw vertical line to separate headers
    doc.line(tableStartX + tableWidth * 0.5, currentYPos, tableStartX + tableWidth * 0.5, currentYPos + rowHeight);

    currentYPos += rowHeight;

    // Draw table rows
    doc.setFont('times', 'normal');
    for (let i = 0; i < payoutTableData.length; i++) {
      // Special formatting for Total row
      if (payoutTableData[i].dateOfPayout === 'Total') {
        doc.setFont('times', 'bold');
        doc.setFillColor(240, 240, 240);
        doc.rect(tableStartX, currentYPos, tableWidth, rowHeight, 'FD');
      } else {
        doc.rect(tableStartX, currentYPos, tableWidth, rowHeight);
      }

      currentYPos += rowHeight;

      // Add text content - centered within each column
      const textY = currentYPos - bottomPad;
      const text1 = payoutTableData[i].dateOfPayout;
      const text2 = payoutTableData[i].amountInINR;

      doc.text(text1, col1CenterX - doc.getTextWidth(text1) / 2, textY);
      doc.text(text2, col2CenterX - doc.getTextWidth(text2) / 2, textY);

      // Draw vertical separator line for each row
      doc.line(tableStartX + tableWidth * 0.5, currentYPos - rowHeight, tableStartX + tableWidth * 0.5, currentYPos);

      // Reset font for next iteration
      if (payoutTableData[i].dateOfPayout === 'Total') {
        doc.setFont('times', 'normal');
      }
    }

    return currentYPos + 10; // Return new Y position with some padding
  }
  setBpmJbFooter(doc, _pageNo) {
    const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    doc.setFont('times', 'normal');
    const fontSize = 8;
    doc.setFontSize(fontSize);
    const addressyPos = 50;
    const addressFresher = [
      'INFOSYS BPM LIMITED',
      '(Formerly Known as Infosys BPO Limited)',
      'CIN: U72200KA2002PLC030310',
      'Plot Nos. 26/3, 26/4 and 26/6,',
      'Electronics City Hosur',
      'Road Bengaluru - 560 100, India',
      'T 91 80 2852 2405',
    ];
    let maxLenght = 0;
    addressFresher.forEach((item) => {
      if (item.length > maxLenght) {
        maxLenght = item.length;
      }
    });
    maxLenght = maxLenght * 4 + 110;

    // Calculate total height needed for all lines (including fax line)
    const totalLines = addressFresher.length + 1; // +1 for fax line
    const startYPos = addressyPos + (totalLines - 1) * lineHeight;

    // Render all address lines from top to bottom by starting from the bottom and working up
    for (let i = 0; i < addressFresher.length; i++) {
      doc.setTextColor(0, 0, 0); // Set text color to black
      doc.text(addressFresher[i], pageWidth - maxLenght, pageHeight - (startYPos - i * lineHeight));
    }

    // Render the fax number and website URL on the line below telephone number
    doc.setTextColor(0, 0, 0); // Set text color to black
    const faxText = 'F 91 80 2852 2411 ';
    doc.text(faxText, pageWidth - maxLenght, pageHeight - (startYPos - addressFresher.length * lineHeight));

    // Render the website URL in blue color right beside the fax number
    doc.setTextColor(0, 0, 255); // Set text color to blue
    doc.text(
      'www.infosysbpm.com',
      pageWidth - maxLenght + doc.getTextWidth(faxText),
      pageHeight - (startYPos - addressFresher.length * lineHeight),
    );
    doc.setTextColor(0, 0, 0); // Reset text color to black
  }
  addHeader(doc: jsPDF) {
    doc.addPage();
    const footerText = 'Company Confidential';
    this.pageNo = this.pageNo + 1;
    const numOfPage = doc.getNumberOfPages();
    for (let i = 1; i <= numOfPage; i++) {
      this.setFooterForInfoBonus(doc, footerText, i);
    }
    this.setLogo(doc);
    //  if((this.dynamicDataPoint['Job_Level'] == "2" && this.dynamicDataPoint['role_cap_code'] == "232BTRAPSE" && this.pageNo == 2 ) || isJB){
    return this.setHeader(doc);
    //  }
  }
  setHeader(doc: jsPDF, isJB?: boolean) {
    const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    doc.setFont('times');
    doc.setFontSize(10);
    const yPos = 100;
    const xPos = 35;
    // Get current page number
    const currentPageNum = doc.getCurrentPageInfo().pageNumber;

    const todayDate = new Date();

    // Only show HRD text and date on first page for joining bonus documents
    if (isJB && currentPageNum === 1) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const lineY = yPos + lineHeight;
      doc.text('HRD/' + 'Joining Bonus' + '/' + this.candidateId, xPos, lineY);
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const dateInFormat = months[todayDate.getMonth()] + ' ' + todayDate.getDate() + ', ' + todayDate.getFullYear();
      doc.text(dateInFormat, pageWidth - xPos, lineY, { align: 'right' });
    }
    // Only one row space after HRD and date line
    return yPos + lineHeight * 2;
  }
}
